import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import localeUk from '@angular/common/locales/uk';
import {registerLocaleData} from '@angular/common';
import {SessionStorage, SessionStorageService} from 'ngx-webstorage';
import {TokenService} from './services/token.service';
import {tap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material/icon';
import {ICONS_NAMES} from './utils/constants/icons';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{
  public viewContent = false;
  private icons: string[] = ICONS_NAMES;
  private tokenService: TokenService = inject(TokenService);
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);
  private destroyRef = inject(DestroyRef);
  private router: Router = inject(Router);
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);
  private translateService: TranslateService = inject(TranslateService);
  @SessionStorage() public userType: any;
  // https://support.dev-miranda.megakit.pro/?userType=passenger&service=3341312913&mirandaToken=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNjRkZTdkYTkxOGVmZmQzNGZhOWM4OWI0YzEzNzk4YmJhMzEwYTJiMTA0ZThhYzM4NjdjOTI0MDdhYjk0ZTBjYWQ1ZDAzZjFhYWEzODRkMWQiLCJpYXQiOjE3MzczNzUxNjguNTU3NTc0LCJuYmYiOjE3MzczNzUxNjguNTU3NTc3LCJleHAiOjE3Njg5MTExNjguNTQ3MzM4LCJzdWIiOiIxMSIsInNjb3BlcyI6W119.akBL5TPGKPQHrblLi8PvQB6j9jzCQrH0ccGxBPVI0oYfX4lmMMe6ZlozGs6SCPzlnLhRIFFihguavPvg4RnOkqRHMP5Y9NumHxxxL5UeumySEDCEjqIpM-SzI1sZ8EIlMHxTPeR9sbTOWNsrGITYPelfj8HKb615m-vsK58YwHRLkmBGf8_SjQhs6Mwh6xgszzIqJpvL3ggcmkR_g0VfL61jKaoRgIRIm4LhbJiIzCIYUo7BCa62bueXOZf2R8q9xjjmZOZuVmCXq4y7QEkW-XAYdmzOBMxT-BxjLsg_WA4sM2yOa28XyV79YshZX66XiCP3kSHkOe6Edmx1B7Z9xjy2LFH7nnOMVyaBpXOYtrOcp-wESVQCiMFI89R71TJmupQRBSw31Gwg1gOlK45U1rEs-Of8IMXB44AdJKdyxfe8JfXQ3P7oEtHCUq6Ftl-YNsayIwWM4Q-swXsVsjGiM5qGIpNdaxgTKgXm3nVdrahEwjGZUtDamcGQ25DQDGRTcGkkxtr0HAfqNcSPMRthxnzrYNVp-r3NAY9cYfiXNHaGxBkp6ezrzlR-oSA1TM3t0au_NB6MRb7M2x0toyQL5kNwAgcwFoFXfWqW22I4RGG-on-I7YE5pg8-6waa4vW270QqvnOKl3a4AM3AfoRM142ufZtxJF7EK6Xhk1OA0T4&app_version=3.23.0-dev-debug&os_version=14&device_name=HONOR&device_model=CRT-LX1&order_id=c8bd4dea-18ec-4517-8391-93c3a49ad76f
  // https://support.dev-miranda.megakit.pro/?userType=driver&service=3341312913&token=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiYjI5ZjJiZTBmNjliYWU2OWU5YzE1YWE5ZDdlYmRiZWEyYTBkZTQ1NWYwZjRmNDdkMzMwMTY2NWE4NzA5OWI0YzRmZjU0ZDEyZDI4ZWZjOTYiLCJpYXQiOjE3Mzc1MzY1NTguMzkzMTI1LCJuYmYiOjE3Mzc1MzY1NTguMzkzMTI3LCJleHAiOjE3NjkwNzI1NTguMzgxMDcxLCJzdWIiOiIyOSIsInNjb3BlcyI6W119.dGWA7HgT7uXBoq_tvDKb6mMP7sVb6JMuNWwVuvpP8TA1zH0FUaFmW9nK0BtxFA9BCfwv4QQiOnAhn13YQ16Vq7XS2_ZwX_f0r53-IfF0RFV12Kltx322t-JtB3X8tHNasB7eGbcAwhiNfgKWOxljiio8A3_9dZO63eleB92PROecITQceAi6KKQTDtREQ8iseX8jbsmY72YkCoddToBq1cgOaiyvqs2htGjrcyMJDDpMEtH3SHRLL9oqFRzbwetkYwtPfd6-myVRL8xmYJFxIhta0S_ldcf6NGfYP49bqXtAk5dpAZQ-2IwCgL04uHamayB_mgwyZF5IQQhssZp22wGh9WsBVA0pYct4SPOAvC9cQnDoPvCtaPBRXycxCO0uKrX0l3bLsA0TEhk1Ui0EqBFrGb4GRyeBq5yaH_lHshfRR1Z6HwBpOtyb2Q1x8H1LbXCv45qXe56gaGUI07QV2WbwKuYEJAwWpUy2V9wXz0cFZcY05ZzZjfun_KasemahD4JUljWoZtBoLILFShuo2n41taS5NtfDBNHTkucm7a3xUlncwrhb8rCPgyXPqoWxFTU5ORjqApKTqivxIibaDiL7pLHiq-9i-0BlnO7LadRppwbGreioKnOfo_fSyRliXRMaN7E2iBu1jnLUgbB9m_eVnelRWeQwMLuEoi7pHFY&order_id=c7b7732f-49d3-41f5-b6f2-861efeef7006



    title = 'Діалог з підтримкою';

  ngOnInit(): void {
    registerLocaleData(localeUk);
    this.orderObserver();
    this.ticketObserver();
    this.setTheme();
    this.initializeTranslations();
    // this.iconsRegistry();
  }

  private setTheme() {
    if(!this.sessionStorageService.retrieve('userType')) {
      // this.sessionStorageService.store('userType', 'passenger');
      // this.sessionStorageService.store('mirandaToken', this.tokenService.developmentMirandaDriverToken);
      // this.sessionStorageService.store('mirandaToken', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNjRkZTdkYTkxOGVmZmQzNGZhOWM4OWI0YzEzNzk4YmJhMzEwYTJiMTA0ZThhYzM4NjdjOTI0MDdhYjk0ZTBjYWQ1ZDAzZjFhYWEzODRkMWQiLCJpYXQiOjE3MzczNzUxNjguNTU3NTc0LCJuYmYiOjE3MzczNzUxNjguNTU3NTc3LCJleHAiOjE3Njg5MTExNjguNTQ3MzM4LCJzdWIiOiIxMSIsInNjb3BlcyI6W119.akBL5TPGKPQHrblLi8PvQB6j9jzCQrH0ccGxBPVI0oYfX4lmMMe6ZlozGs6SCPzlnLhRIFFihguavPvg4RnOkqRHMP5Y9NumHxxxL5UeumySEDCEjqIpM-SzI1sZ8EIlMHxTPeR9sbTOWNsrGITYPelfj8HKb615m-vsK58YwHRLkmBGf8_SjQhs6Mwh6xgszzIqJpvL3ggcmkR_g0VfL61jKaoRgIRIm4LhbJiIzCIYUo7BCa62bueXOZf2R8q9xjjmZOZuVmCXq4y7QEkW-XAYdmzOBMxT-BxjLsg_WA4sM2yOa28XyV79YshZX66XiCP3kSHkOe6Edmx1B7Z9xjy2LFH7nnOMVyaBpXOYtrOcp-wESVQCiMFI89R71TJmupQRBSw31Gwg1gOlK45U1rEs-Of8IMXB44AdJKdyxfe8JfXQ3P7oEtHCUq6Ftl-YNsayIwWM4Q-swXsVsjGiM5qGIpNdaxgTKgXm3nVdrahEwjGZUtDamcGQ25DQDGRTcGkkxtr0HAfqNcSPMRthxnzrYNVp-r3NAY9cYfiXNHaGxBkp6ezrzlR-oSA1TM3t0au_NB6MRb7M2x0toyQL5kNwAgcwFoFXfWqW22I4RGG-on-I7YE5pg8-6waa4vW270QqvnOKl3a4AM3AfoRM142ufZtxJF7EK6Xhk1OA0T4');
      // this.sessionStorageService.store('mirandaToken', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiZTQwYTZlMWEwMmQxNDI4ZDM5ZDUzODQ2YjYzMzMwMzE0MTMxOTlkODNkOTJiNWVmNjVjNDlmZTI3Yjk1NmViOGFhMDRhN2I2Mjc2MmQ5MzAiLCJpYXQiOjE3Mzc3MTA5OTMuOTQ3NzYsIm5iZiI6MTczNzcxMDk5My45NDc3NjIsImV4cCI6MTc2OTI0Njk5My45MzUyODYsInN1YiI6IjI5Iiwic2NvcGVzIjpbXX0.r0zpSaPJEuffBiqzMrKHDaZ4By6NFDQrqVEVuPMwWd5Onp2E2MsydCTIGV0MRTMdG_JQSKbegKDuN1DzlfLt7E3XE58RnWZsP52Q0PyxhQfb4LdOi2V0PJlqXo66Gtm7j5A7FJz_OoL-9I-mEcHxRViWaac_kPLtLLobQ0CNR_Jdk2R-b2s2-k1U_-38xSrIBmKawVsPrSUQor3ItrShQ-64GkUWuv3cqohYqVuPA6vg-fl7AD8WyxcinMSmHLKN1Xg55Cdyc176v1cWG1FAH09lkxOEZoxIC9XLRWiQSNIewEpgCknV3h6ci5rn1jAR9j7jLjZ1fSgH2gpDPnlNBPz0nqQHKaPCLAzrF2tGP5drOHbpg5fYBcALHl4KT7SV-1hs8DkDvklny2QtzppwhS2erl1GZsal79c0hytFtd2o0Rr6V4SG-ncmqrwl7CNmPL1Ojbbnl7dnQiS0RWAwivkTHyHMFnEDgCtolOv8xIdZID5h5bxEUVzY4JRVHqQ7s8qXtploh17RJFVuVt0d54DGIbfoAG5bCtkFsFDHxfd6EwA3e5JGZcq6crXvxwmqQEDR6eXEr6d1jvwuM2BUNoNFXypuhh1m3M0RKmRX5L2oLANPaELxafgNk9_on7KCo_N6avcuak1KQWcl5mkb5nGdd7w7pVnLAlcDY02xOB4');
      // this.sessionStorageService.store('service', '3341312913');
      // this.sessionStorageService.store('order_id', 'c8bd4dea-18ec-4517-8391-93c3a49ad76f');
      // this.sessionStorageService.store('order_id', '65537611-9bb9-4d56-b1bd-9cf20b6253d5');
      // this.sessionStorageService.store('device', {
      //   device_name: 'HONOR',
      //   model: 'CRT-LX1',
      //   device_id: 'qwertyass',
      //   device_type: 'mobile',
      // })
      // this.sessionStorageService.store('application', {
      //   app_version: '3.23.0-dev-debug',
      //   app_name: 'Name',
      //   os_version: '14',
      //   os_name: 'android',
      // })


      this.sessionStorageService.store('userType', new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('userType'));
      this.sessionStorageService.store('mirandaToken', new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('mirandaToken'));
      this.sessionStorageService.store('service', new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('service'));
      this.sessionStorageService.store('device', {
        device_name: new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('device_name'),
        model: new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('device_model'),
        device_id: new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('device_id'),
        device_type: new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('device_type'),
      })
      this.sessionStorageService.store('application', {
        app_version: new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('app_version'),
        app_name: new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('app_name'),
        os_version: new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('os_version'),
        os_name: new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('os_name'),
      })
      this.sessionStorageService.store('order_id', new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('order_id'));
      this.sessionStorageService.store('ticket_uuid', new URLSearchParams(new URL(location.toString().replace('#/', '')).search).get('ticket_uuid'));
    }
    this.userType = this.userType || this.sessionStorageService.retrieve('userType');
    const body = document.getElementsByTagName('body')[0];
    if (this.userType) {
      body.classList.add(this.userType);
    }
    if(!this.sessionStorageService.retrieve('token')) {
      this.getToken();
    } else {
      this.viewContent = true;
    }
  }

  private getToken() {
    this.tokenService.getOctobusToken().pipe(
      tap((resp) => {
        this.sessionStorageService.store('token', resp);
        this.viewContent = true;
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }

  private orderObserver() {
    this.sessionStorageService.observe('order_id').pipe(
      tap((order_id) => {
        if(order_id){
          this.router.navigate(['/trip-details']);
        }
        }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }

  private ticketObserver() {
    this.sessionStorageService.observe('ticket_uuid').pipe(
      tap((ticket_uuid) => {
        if(ticket_uuid){
          this.router.navigate(['/chat'], {queryParams: {ticket_uuid}});
        }
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }

  private iconsRegistry() {
    this.icons.forEach(icon => {
      this.iconRegistry.addSvgIcon(icon, this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${icon}.svg`));
    });
  }

  private initializeTranslations() {
    this.translateService.setFallbackLang('uk');
    const currentUserType = this.userType || this.sessionStorageService.retrieve('userType');
    if (currentUserType === 'dispatcher') {
      this.translateService.use('uk');
    }
  }


}
